var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVacancyLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 35,
    viewBox: "0 0 215 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.1205 25.3119C90.1586 26.3543 91.3852 27.1744 92.8001 27.7753C94.2151 28.3762 95.7887 28.6915 97.4846 28.6982C98.7409 28.6982 99.9674 28.509 101.131 28.0973C102.295 27.7155 103.363 27.181 104.338 26.4539C105.283 25.7601 106.1 24.9069 106.791 23.9275C107.482 22.9515 107.984 21.8758 108.298 20.6773H103.363C103.144 21.245 102.83 21.7497 102.42 22.1912C102.01 22.6328 101.541 23.0113 101.005 23.2968C100.47 23.6122 99.9377 23.8645 99.3393 24.0238C98.7409 24.1798 98.1128 24.2761 97.4846 24.2761C96.4168 24.2761 95.4416 24.0869 94.5919 23.7084C93.7092 23.3632 92.9554 22.8585 92.3273 22.1946C91.6992 21.5306 91.2298 20.7736 90.8826 19.9204C90.5388 19.0705 90.3801 18.121 90.3801 17.1118C90.3801 16.1026 90.5355 15.1564 90.8826 14.3032C91.2265 13.45 91.6992 12.693 92.3273 12.029C92.9587 11.3651 93.7125 10.8605 94.5919 10.482C95.4416 10.1334 96.4168 9.94415 97.4846 9.94415C98.1128 9.94415 98.7409 10.0371 99.3393 10.1965C99.9377 10.3525 100.47 10.6048 101.005 10.8903C101.541 11.2057 102.01 11.5842 102.42 12.0257C102.827 12.4673 103.141 12.9719 103.363 13.5396H108.298C107.984 12.3411 107.482 11.2356 106.791 10.2563C106.1 9.27691 105.28 8.45686 104.338 7.72981C103.363 7.03264 102.295 6.49815 101.131 6.08649C99.9674 5.70802 98.7409 5.5188 97.4846 5.5188C95.7854 5.5188 94.2151 5.80096 92.8001 6.40186C91.3852 7.00276 90.1586 7.82274 89.1205 8.86518C88.0825 9.90763 87.2659 11.1393 86.6675 12.5603C86.0725 13.9812 85.7882 15.495 85.7882 17.1052C85.7882 18.7153 86.0692 20.2291 86.6675 21.65C87.2659 23.071 88.0825 24.2694 89.1205 25.3119Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.2243 16.224C59.5643 15.6218 58.7491 15.1494 57.8383 14.8001C56.8977 14.4541 55.8944 14.2944 54.7955 14.2911H48.4162V10.2424H60.4751V5.87765H43.8354V28.3401H54.7955C55.8911 28.3401 56.8977 28.1505 57.8383 27.8012C58.7491 27.4552 59.5643 26.9795 60.2243 26.3474C60.8843 25.7452 61.4157 24.9868 61.8249 24.1318C62.2012 23.2801 62.3893 22.3619 62.3893 21.3173C62.3893 20.2727 62.2012 19.3246 61.8249 18.4696C61.4157 17.6146 60.8843 16.8561 60.2243 16.224ZM54.7328 18.5028C55.7063 18.5028 56.4885 18.7557 57.0859 19.2314C57.6832 19.7038 57.9637 20.3991 57.9637 21.3173C57.9637 22.2355 57.6832 22.8975 57.0859 23.3732C56.4885 23.849 55.7063 24.1018 54.7328 24.1018H48.4162V18.5028H54.7328Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.615 5.88694V15.0293H128.95L134.185 8.45008V15.0293H135.716V5.88694H134.381L129.159 12.4551V5.88694H127.615Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.944 10.2135L116.698 5.88779H115.297V15.0302H116.828V8.46198L119.957 12.6218L123.059 8.47525V15.0302H124.603V5.88779H123.203L119.944 10.2135Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.679 11.8624H140.252V15.0293H138.721V5.88694H141.679C143.59 5.88694 144.898 7.18731 144.898 8.8747C144.898 10.5621 143.59 11.8624 141.679 11.8624ZM141.666 7.30452H140.252V10.4471H141.666C142.765 10.4471 143.395 9.76372 143.395 8.8769C143.395 7.98566 142.765 7.30452 141.666 7.30452Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.297 18.7533V27.8957H116.632L121.868 21.3165V27.8957H123.398V18.7533H122.063L116.841 25.3215V18.7533H115.297Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126.404 18.7533H127.934V22.5394H132.529V18.7533H134.06V27.8957H132.529V23.9681H127.934V27.8957H126.404V18.7533Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.281 18.7533H137.075V27.8957H140.687C142.454 27.8957 143.684 26.7236 143.684 25.2176C143.684 24.0853 143.041 23.3887 142.191 23.0415C142.701 22.6677 143.054 22.1016 143.054 21.2767C143.054 19.8989 141.944 18.7533 140.281 18.7533ZM141.551 21.3673C141.551 22.075 141.04 22.6036 140.202 22.6036H138.606V20.1311H140.202C141.04 20.1311 141.551 20.6972 141.551 21.3673ZM142.191 25.2043C142.191 25.9761 141.643 26.5179 140.647 26.5179H138.606V23.8907H140.647C141.641 23.8907 142.191 24.4435 142.191 25.2043Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M146.115 18.7533H151.703V20.1952H147.646V22.5394H150.919V23.9813H147.646V26.4538H151.703V27.8957H146.115V18.7533Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M158.27 18.5988C155.496 18.5988 153.428 20.6467 153.428 23.3248C153.428 26.003 155.496 28.0508 158.27 28.0508C160.507 28.0508 162.287 26.62 162.745 24.8309H161.095C160.702 25.8747 159.576 26.5956 158.268 26.5956C156.332 26.5956 154.97 25.167 154.97 23.3248C154.97 21.4826 156.33 20.054 158.268 20.054C159.578 20.054 160.702 20.7749 161.095 21.8188H162.745C162.289 20.0275 160.509 18.5988 158.27 18.5988Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M166.906 20.1952H164.208V18.7533H171.145V20.1952H168.436V27.8957H166.906V20.1952Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M173.321 18.7533V27.8957H174.656L179.892 21.3165V27.8957H181.422V18.7533H180.087L174.865 25.3215V18.7533H173.321Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M192.857 26.4538V29.802H191.443V27.8957H184.427V18.7533H185.972V26.4538H190.135V18.7533H191.679V26.4538H192.857Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M195.177 18.7533V27.8957H196.512L201.748 21.3165V27.8957H203.278V18.7533H201.943L196.721 25.3215V18.7533H195.177Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M206.285 27.8957V18.7533H207.829V25.3215L213.051 18.7533H214.386V27.8957H212.856V21.3164L207.62 27.8957H206.285Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M208.288 16.0353H209.295C209.295 16.8071 209.74 17.2848 210.459 17.2848C211.179 17.2848 211.624 16.8094 211.624 16.0353H212.631C212.631 17.349 211.662 18.1739 210.457 18.1739C209.257 18.1739 208.288 17.349 208.288 16.0353Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9393 28.3401H66.5511V5.87765H70.9393V15.399L78.7441 5.87765H84.1995L75.2976 16.6664L86.0564 28.3401H80.3268L70.9393 18.1535V28.3401Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.313 34.5851C26.8747 34.5851 34.626 26.8429 34.626 17.2925C34.626 7.74213 26.8747 0 17.313 0C7.75129 0 0 7.74213 0 17.2925C0 26.8429 7.75129 34.5851 17.313 34.5851Z",
    fill: "url(#paint0_linear_4364_5240)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85379 2.95284C2.09786 8.18245 2.72251 17.6048 9.25076 23.9961C15.7767 30.3873 25.7326 31.3311 31.4908 26.0992C32.1432 25.5065 32.7137 24.86 33.2029 24.1702C34.1186 22.0624 34.6263 19.7367 34.6263 17.2925C34.6263 7.74213 26.875 0 17.3133 0C14.0951 0 11.0819 0.877067 8.50034 2.40495C8.27948 2.57938 8.06384 2.762 7.85379 2.95284Z",
    fill: "url(#paint1_radial_4364_5240)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02949 2.9518C6.30518 7.09603 9.47785 13.5363 16.1168 17.3327C22.7557 21.1314 30.3437 20.8495 33.0703 16.703C33.8403 15.532 34.1398 14.1782 34.0237 12.7526C32.0273 5.40445 25.3023 0 17.3135 0C14.9009 0 12.6036 0.49289 10.517 1.38335C9.92937 1.82333 9.42748 2.34637 9.02949 2.9518Z",
    fill: "url(#paint2_radial_4364_5240)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4364_5240",
    x1: 26.6673,
    y1: 56.0788,
    x2: 14.9069,
    y2: -22.1149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303516,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733277,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4364_5240",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.4233 18.7715) rotate(106.278) scale(31.2887 26.3406)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279744,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.450971,
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4364_5240",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.6175 -6.33823) rotate(53.1036) scale(43.8399 48.9075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136507,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397079,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725487,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacancyLogo);
export default __webpack_public_path__ + "static/media/vacancy_logo.d7541e3583f9945c34cc4c24882bc762.svg";
export { ForwardRef as ReactComponent };